module.exports = __webpack_public_path__ + "img/621.Machine_ailure.9f662a87.svg";